import {
  AssetAttribute,
  AssetEntityDetails,
  AssetEntityWire,
  AssetSource,
  AssetSourceWire
} from 'models'
import { sanitizeAssetValue } from 'lib/sanitizeAssetValue'

/**
 * Array columns keep every element here, unlike the grid cell, which prints the one element the
 * merge settled on — the pane is where the whole value belongs.
 */
const valueText = (value: unknown): string | null => {
  if (!Array.isArray(value)) return sanitizeAssetValue(value)

  const parts = value.map(sanitizeAssetValue).filter((part): part is string => !!part)

  return parts.length ? sanitizeAssetValue(parts.join(', ')) : null
}

export const toSource = (wire: AssetSourceWire): AssetSource => ({
  product: sanitizeAssetValue(wire.product_name) ?? '',
  instance: sanitizeAssetValue(wire.instance_name) ?? '',
  displayName: sanitizeAssetValue(wire.instance_display_name)
})

export const toAssetEntityDetails = (wire: AssetEntityWire): AssetEntityDetails => {
  const attributes: Record<string, AssetAttribute> = {}

  for (const attribute of wire.attributes) {
    attributes[attribute.name] = {
      column: attribute.name,
      rule: attribute.rule,
      resolved: valueText(attribute.default_value),
      values: (attribute.values ?? [])
        .map((entry) => ({ text: valueText(entry.value), sources: (entry.sources ?? []).map(toSource) }))
        .filter((entry): entry is { text: string; sources: AssetSource[] } => !!entry.text)
    }
  }

  return {
    id: wire.entity_id,
    memberCount: wire.member_count ?? 1,
    sources: (wire.sources ?? []).map(toSource),
    attributes,
    members: wire.members ?? []
  }
}
